import DataModel from '../../common/model/DataModel';

export default class ManageColumnDefaultsDataModel extends DataModel {
  constructor() {
    super();

    this.popupSessionId = crypto.randomUUID();
    this.popupTitle = '';
    this.popupVisible = false;
    this.counterpartyName = '';
    this.columnSettings = null;
  }
}